<template>
  <div class="sidebar" :class="{ active: menuToggler }">
    <div class="close_menu" @click="close">
      <base-icon name="close-circle" />
    </div>
    <div class="sidebar__logo">
      <router-link :to="{ name: 'Home' }" class="sidebar__logo-link a-logo">
        <base-icon name="logo" />
      </router-link>
    </div>
    <ul class="sidebar__menu">
      <li>
        <router-link
          class="sidebar__link m-text-white"
          :class="selectedMenuName === 'dashboard' ? 'menu-active' : ''"
          :to="{ name: 'Home' }"
        >
          Dashboard
        </router-link>
      </li>
      <li>
        <div class="sidebar__link m-text-white sidebar__link-subtitle">
          Raporlar
          <router-link
            class="sidebar__link-subtitle-link"
            :class="
              selectedMenuName === 'musteri-raporlari' ? 'menu-active' : ''
            "
            :to="'/reports/represreports'"
            >Müşteri Raporları</router-link
          >
          <router-link
            v-if="userType === 1"
            class="sidebar__link-subtitle-link"
            :class="
              selectedMenuName === 'manuel-musteri-raporlari'
                ? 'menu-active'
                : ''
            "
            :to="{ name: 'GetManuelReport' }"
            >Manuel Rapor Al</router-link
          >
        </div>
      </li>
      <li v-if="userType === 1">
        <router-link
          class="sidebar__link m-text-white"
          :class="selectedMenuName === 'onerilen-paketler' ? 'menu-active' : ''"
          :to="{ name: 'RecommendedPackages' }"
        >
          En Çok Kullanılan Paketler
        </router-link>
      </li>
      <li v-if="userType === 1">
        <router-link
          :to="{ name: 'MonthClosing' }"
          :class="
            selectedMenuName === 'ay-kapama-islemleri' ? 'menu-active' : ''
          "
          class="sidebar__link m-text-white"
        >
          Ay Kapama Yönetimi
        </router-link>
      </li>
      <li v-if="userType === 1">
        <div class="sidebar__link m-text-white sidebar__link-subtitle">
          Site Ayarları
          <router-link
            :to="{ name: 'ProductAndPackageManagement' }"
            :class="
              selectedMenuName === 'urun-ve-paket-yonetimi' ? 'menu-active' : ''
            "
            class="sidebar__link-subtitle-link"
            >Ürün ve Paket Yönetimi</router-link
          >

          <router-link
            class="sidebar__link-subtitle-link"
            :class="
              selectedMenuName === 'global-parameters' ? 'menu-active' : ''
            "
            :to="{ name: 'ParametersPage' }"
            >Global Parametreler</router-link
          >

          <router-link
            class="sidebar__link-subtitle-link"
            :class="selectedMenuName === 'users-role' ? 'menu-active' : ''"
            :to="{ name: 'UsersRole' }"
            >Kullanıcı Rolleri</router-link
          >
        </div>
      </li>
      <li class="sidebar__logout">
        <a
          @click="signOut()"
          class="sidebar__link m-text-white sign-out"
          id="sign-out"
        >
          <base-icon name="logout" /> Güvenli Çıkış
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BaseIcon } from "@/components";
import mixins from "../../mixins";

export default {
  name: "SideBar",
  data() {
    return {
      userType: null,
    };
  },
  props: {
    menuToggler: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixins],
  components: {
    BaseIcon,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    selectedMenuName() {
      return this.$route.meta.baseMenuName;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    signOut() {
      this.$toast.clear();
      return this.logout();
    },
    close() {
      this.$emit("closeMenu");
    },
  },
  mounted() {
    this.userType = this.getUserInfo.memberType;
  },
};
</script>

<style lang="scss">
.osm-vd-styles {
  .sidebar {
    background-color: var(--color-primary-default);
    width: 240px;
    flex: 0 0 240px;
    position: relative;
    transition: all 1s ease-in-out;
    .close_menu {
      display: none;
    }
    @media (max-width: 820px) {
      position: fixed;
      left: -100%;
      z-index: 6;
      height: 100vh;
      .close_menu {
        display: block;
        filter: brightness(0) invert(1);
        padding: 10px 10px 0px 0px;
        text-align: right;
      }
      &.active {
        left: 0px;
        overflow-y: scroll;
      }
    }
    .a-logo {
      background-color: transparent !important;
    }
    svg {
      fill: var(--grayscale-0);
    }
    &__logo {
      padding: 20px;
      text-align: center;

      &-link {
        display: block;
      }
    }
    &__menu {
      position: sticky;
      top: 0px;
      height: 100vh;

      &::before {
        content: "";
        display: block;
        width: 200px;
        background: var(--grayscale-0);
        height: 1px;
        margin: 0 auto;
      }
    }
    &__link {
      text-decoration: none;
      padding: 14px 32px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;

      svg {
        margin-right: 16px;
      }
      &-subtitle {
        &-link {
          display: block;
          width: 100%;
          text-decoration: none;
          color: #fff;
          padding: 10px 0px 10px 16px;
          margin-top: 10px;
          font-weight: normal;
          &:hover {
            background-color: var(--color-primary-light);
          }
          &:first-child {
            margin-top: 27px;
          }
        }
      }
    }
    .menu-active {
      position: relative;
      background-color: var(--color-primary-light);

      &::before {
        content: "";
        background: var(--grayscale-0);
        width: 4px;
        border-radius: 0px 2px 2px 0px;
        display: inline-block;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
      }
    }
    &__logout {
      position: absolute;
      bottom: 100px;
      left: 0px;
      width: 100%;

      &::before {
        content: "";
        display: block;
        width: 200px;
        background: var(--grayscale-0);
        height: 1px;
        margin: 0 auto;
      }
      cursor: pointer;
      @media (max-width: 768px) {
        position: relative;
        bottom: 0px;
      }
    }
  }
}
</style>
